import { APP_ENVS } from 'data/appEnvs';

export const getEnvironment = () => {
  return process.env.REACT_APP_ENV;
};

export const isDevelopment = () => getEnvironment() === APP_ENVS.development;

export const isStaging = () => getEnvironment() === APP_ENVS.staging;

export const isProduction = () => getEnvironment() === APP_ENVS.production;
